var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMacAppDarkIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_966",
    "data-name": "Rectangle 966",
    width: 11.413,
    height: 14,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Apple_-_color",
    "data-name": "Apple - color",
    transform: "translate(-770 -621)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3124",
    "data-name": "Group 3124",
    transform: "translate(771.293 621)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3123",
    "data-name": "Group 3123",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1029",
    "data-name": "Path 1029",
    d: "M246.9,1.218A3,3,0,0,1,249.1,0a2.99,2.99,0,0,1-.724,2.238,2.364,2.364,0,0,1-2.085.981,2.6,2.6,0,0,1,.61-2",
    transform: "translate(-240.603 0)",
    fill: "#5d5d5d",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1030",
    "data-name": "Path 1030",
    d: "M5.8,147.029a12.675,12.675,0,0,1,2.495-.65,3.125,3.125,0,0,1,2.742,1.4,3.04,3.04,0,0,0-1.514,2.652,3.117,3.117,0,0,0,1.886,2.849s-1.318,3.711-3.1,3.711c-.818,0-1.454-.551-2.316-.551-.878,0-1.75.572-2.317.572-1.626,0-3.681-3.52-3.681-6.35,0-2.784,1.739-4.245,3.37-4.245,1.06,0,1.883.611,2.434.611",
    transform: "translate(0 -143.012)",
    fill: "#5d5d5d",
    fillRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_967",
    "data-name": "Rectangle 967",
    width: 14,
    height: 14,
    transform: "translate(770 621)",
    fill: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMacAppDarkIcon);
export default __webpack_public_path__ + "static/media/mac-app-dark-icon.2297d8f7b650d9284d20076ceddf7d6a.svg";
export { ForwardRef as ReactComponent };